import {register} from 'vue-advanced-chat';

export default defineNuxtPlugin(() => {
  register();
});
